<template>
  <v-card outlined>
    <v-tabs v-model="activeTab" color="primary" slider-color="primary">
      <v-tab href="#pending">
        Pendientes de Entrega
        <v-badge v-if="localCount > 0" color="error" :content="localCount" class="ml-2 mb-1">
        </v-badge>
      </v-tab>
      <v-tab href="#history">
        Historial de Entregas
      </v-tab>
    </v-tabs>

    <v-divider></v-divider>

    <v-tabs-items v-model="activeTab">
      <v-tab-item value="pending" eager>
        <PendingDeliveriesTable
          ref="pendingTable"
          @update-count="fetchReadyCount"
          @error="msg => $emit('error', msg)"
          @pagination="val => $emit('pagination-change', val)"
        />
      </v-tab-item>

      <v-tab-item value="history" eager>
        <HistoryDeliveriesTable
          ref="historyTable"
          @error="msg => $emit('error', msg)"
          @pagination="val => $emit('pagination-change', val)"
        />
      </v-tab-item>

    </v-tabs-items>
  </v-card>
</template>

<script>
import ClientDeliveryService from '@/services/ClientDeliveryService';
import PendingDeliveriesTable from './PendingDeliveriesTable.vue';
import HistoryDeliveriesTable from './HistoryDeliveriesTable.vue';

export default {
  name: 'DeliveryTable',
  components: {
    PendingDeliveriesTable,
    HistoryDeliveriesTable,
  },
  props: {
    initialTab: { type: String, default: 'pending' },
    pendingItems: { type: Array, default: () => [] },
    historyItems: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    historyLoading: { type: Boolean, default: false },
    pendingCount: { type: Number, default: 0 },
    storeId: { type: [Number, String], required: true },
  },
  data() {
    return {
      activeTab: this.initialTab,
      localCount: 0,
    };
  },
  watch: {
    activeTab(newVal) {
      const cleanTab = newVal.replace('#', '');
      this.$emit('change-tab', cleanTab);
      this.fetchReadyCount();
    },
    storeId() {
      this.fetchReadyCount();
    },
  },
  mounted() {
    this.fetchReadyCount();
  },
  methods: {
    async fetchReadyCount() {
      if (!this.storeId) return;
      try {
        const count = await ClientDeliveryService.getReadyToDeliverCount(this.storeId);
        this.localCount = typeof count === 'number' ? count : (count?.data || 0);
      } catch (error) {
        console.error('Error al obtener conteo global de órdenes listas:', error);
      }
    },
    triggerFetch(tabName, params) {
      this.$nextTick(() => {
        if (tabName === 'pending') {
          if (this.$refs.pendingTable) {
            this.$refs.pendingTable.loadData(params);
          }
        } else if (tabName === 'history') {
          if (this.$refs.historyTable) {
            this.$refs.historyTable.loadData(params);
          }
        }
        this.fetchReadyCount();
      });
    },
  },
};
</script>
